import { ref, computed } from 'vue';

// Shared pagination state. Used by the UserProfile views and the header search form.
// Candidates for future consolidation (they reimplement this inline, with their own
// pageSize/quirks — would need partial-data tolerance here):
//   - Components/Search/SearchProjectsResults.vue (pageSize 12)
//   - Components/ProjectExplorer/ProjectExplorer.vue (pageSize 24)
export const usePagination = (initialPageSize = 50) => {
    const availableOrder = ref({});
    const firstItemNumber = ref(1);
    const lastItemNumber = ref(0);
    const order = ref(0);
    const pageIndex = ref(0);
    const pageSize = ref(initialPageSize);
    const pagedItems = ref([]);
    const totalItemCount = ref(0);
    const totalPageCount = ref(0);

    const setPaginationData = (data, reset = false) => {
        availableOrder.value = data.availableOrder;
        firstItemNumber.value = data.firstItemNumber;
        lastItemNumber.value = data.lastItemNumber;
        order.value = data.order;
        pageIndex.value = data.pageIndex;
        pageSize.value = data.pageSize;
        pagedItems.value = reset ? data.pagedItems : [...pagedItems.value, ...data.pagedItems];
        totalItemCount.value = data.totalItemCount;
        totalPageCount.value = data.totalPageCount;
    };

    const resetPaginationData = () => {
        availableOrder.value = {};
        firstItemNumber.value = 1;
        lastItemNumber.value = 0;
        order.value = 0;
        pageIndex.value = 0;
        pageSize.value = initialPageSize;
        pagedItems.value = [];
        totalItemCount.value = 0;
        totalPageCount.value = 0;
    };

    const hasPagedItems = computed(() => pagedItems.value.length > 0);
    const hasMorePagedItems = computed(() => pageIndex.value < totalPageCount.value - 1);

    return {
        availableOrder,
        firstItemNumber,
        lastItemNumber,
        order,
        pageIndex,
        pageSize,
        pagedItems,
        totalItemCount,
        totalPageCount,
        setPaginationData,
        resetPaginationData,
        hasPagedItems,
        hasMorePagedItems,
    };
};
